import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../styles/admin.css';

const AdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="admin-sidebar">
      <div className="admin-sidebar-logo">
        <h2>🔧 ADMIN</h2>
      </div>

      <ul className="admin-nav">
        <li className="admin-nav-item">
          <Link
            to="/admin/dashboard"
            className={`admin-nav-link ${isActive('/admin/dashboard') ? 'active' : ''}`}
          >
            <span>📊</span>
            <span>Dashboard</span>
          </Link>
        </li>

        <li className="admin-nav-item">
          <Link
            to="/admin/products"
            className={`admin-nav-link ${isActive('/admin/products') ? 'active' : ''}`}
          >
            <span>📦</span>
            <span>Бүтээгдэхүүн</span>
          </Link>
        </li>

        <li className="admin-nav-item">
          <Link
            to="/admin/users"
            className={`admin-nav-link ${isActive('/admin/users') ? 'active' : ''}`}
          >
            <span>👥</span>
            <span>Хэрэглэгч</span>
          </Link>
        </li>

        <li className="admin-nav-item">
          <Link
            to="/admin/orders"
            className={`admin-nav-link ${isActive('/admin/orders') ? 'active' : ''}`}
          >
            <span>📋</span>
            <span>Захиалга</span>
          </Link>
        </li>

        <li className="admin-nav-item">
          <Link
            to="/admin/messages"
            className={`admin-nav-link ${isActive('/admin/messages') ? 'active' : ''}`}
          >
            <span>💬</span>
            <span>Мессеж</span>
          </Link>
        </li>

        <li className="admin-nav-item">
          <Link
            to="/admin/settings"
            className={`admin-nav-link ${isActive('/admin/settings') ? 'active' : ''}`}
          >
            <span>⚙️</span>
            <span>Тохиргоо</span>
          </Link>
        </li>

        <li className="admin-nav-item" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)', marginTop: '20px', paddingTop: '20px' }}>
          <button
            onClick={handleLogout}
            className="admin-nav-link"
            style={{ width: '100%', background: 'none', border: 'none', justifyContent: 'flex-start', cursor: 'pointer' }}
          >
            <span>🚪</span>
            <span>Гарах</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default AdminSidebar;
